import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'findQuestion',
  standalone: true
})
export class FindQuestionPipe implements PipeTransform {

  transform(questions: any[], questionNumber: string): any {
    if (!questions || !questionNumber) {
      return null;
    }
    return questions.find(q => q.question_number == questionNumber);
  }

}
